export const blogData = [
    {
        id: 1,
        title: "Beyond Passive Recording: Why India's Commercial Fleets Are Ready for an AI Dash Cam Mandate",
        description: 'An analysis of how AI-powered dash cams can transform fleet safety and compliance in India\'s commercial transportation sector.',
        date: 'Jan 27, 2026',
        image: 'https://telematicswire.net/wp-content/uploads/2026/01/TW_Ravi_T_Alchuri_2-e1769529464313.jpg',
        url: 'https://telematicswire.net/beyond-passive-recording-why-indias-commercial-fleets-are-ready-for-an-ai-dash-cam-mandate/',
        source: 'Telematics Wire'
    },
    {
        id: 2,
        title: 'WeGuard: The Ultimate Mobile Device Management Solution for Your Business',
        description: 'WeGuard is designed to help businesses manage and secure their mobile devices, including smartphones and tablets.',
        date: 'Mar 27, 2023',
        image: 'https://miro.medium.com/v2/resize:fit:4800/format:webp/1*Z-Ytgj_3KiTQUGHTGsWDog.png',
        url: 'https://medium.com/@raviteja.alchuri/weguard-the-ultimate-mobile-device-management-solution-for-your-business-e5745cb48f8c',
        source: 'Medium'
    },
    {
        id: 3,
        title: 'Java Frameworks: Which One Should You Use for RESTful Web Services?',
        description: 'Java has long been a popular language for building web applications, and RESTful web services are no exception.',
        date: 'Mar 24, 2023',
        image: 'https://miro.medium.com/v2/resize:fit:4800/format:webp/1*g-g8hmZLj7_NF-2deDJFtA.jpeg',
        url: 'https://medium.com/@raviteja.alchuri/java-frameworks-which-one-should-you-use-for-restful-web-services-672c745fcec3',
        source: 'Medium'
    },
    {
        id: 4,
        title: 'ChatGPT: A Breakthrough in Conversational AI',
        description: 'ChatGPT is an artificial intelligence (AI) language model developed by OpenAI',
        date: 'Mar 23, 2023',
        image: 'https://miro.medium.com/v2/resize:fit:4800/format:webp/1*tno_BnxV2e3T1F95dF5QxQ.jpeg',
        url: 'https://medium.com/@raviteja.alchuri/chatgpt-a-breakthrough-in-conversational-ai-6f623c4805f0',
        source: 'Medium'
    },
    {
        id: 5,
        title: 'Driving into the Future: The Role of Software in Self-Driving Cars',
        description: 'Self-driving cars are no longer just a figment of our imagination. They are a reality, and they are becoming more common every day.',
        date: 'Mar 24, 2023',
        image: 'https://miro.medium.com/v2/resize:fit:1400/format:webp/1*HhRyZc2de1reD40qIWrfVQ.jpeg',
        url: 'https://medium.com/@raviteja.alchuri/driving-into-the-future-the-role-of-software-in-self-driving-cars-8c36b69d89cb',
        source: 'Medium'
    },
    {
        id: 6,
        title: 'Latest buzz word Blockchain',
        description: 'Decentralized, distributed and public digital ledger that is used to record transactions across many computers.',
        date: 'Sep 27, 2021',
        image: 'https://miro.medium.com/v2/resize:fit:720/format:webp/1*qRVTdbnpoa5dp5B6zEwfcw.png',
        url: 'https://medium.com/@raviteja.alchuri/latest-buzz-word-blockchain-c6bdc28b76d5',
        source: 'Medium'
    },
]
